import { groupGamesList } from "@/api/game";
import { defineStore } from "pinia";
import { Ref, ref } from "vue";

interface GameGroup {
  groupId: string;
  id: number;
  name: string;
  customIcon: string;
  games: any[]; 
  [key: string]: any; 
}

export const useGameStore = defineStore("Game", () => {
  const groupList: Ref<GameGroup[]> = ref([]);

  const getGameGroupListData = async (): Promise<void> => {
    const params = {
      pageNo: "1",
      pageSize: "50"
    };
    try {
      const res = await groupGamesList(params);
        if (res) {
          const data = res.data;
          const favoriteGame = data.favGameList;
          delete data.favGameList;

          const groupArray = Object.entries(data).map(([key, value]) => {
          const group = value as Record<string, any>;
            return {
              groupId: key,
              id: group.id,
              name: group.name,
              customIcon: group.customIcon,
              games: group.games,
              ...group
            };
          });

        if (favoriteGame) {
          const favoriteGroup = {
            groupId: 'favoriteGame',
            id: favoriteGame.id ?? 'fav',
            name: favoriteGame.name ?? 'games.favorite',
            customIcon: favoriteGame.customIcon ?? require('@/assets/common/gg_fav.png'),
            games: favoriteGame.games ?? [],
            ...favoriteGame
          };
          if(favoriteGame.games.length > 0){
              groupArray.splice(1, 0, favoriteGroup); 
          }
        }

        groupList.value = groupArray;
          return Promise.resolve();
        } else {
          return Promise.reject();
        }
      } catch (error) {
        console.error("getGameGroupList failed:", error);
      }
    
  };

  const resetGroupList = () => {
    groupList.value = []
    getGameGroupListData()
  }

  return {
    groupList,
    getGameGroupListData,
    resetGroupList
  };
}, {
  persist: true,
});
